import { Controller } from "@hotwired/stimulus";

import { composeMixins } from "./utils/compose_mixins";

import { BaseMixin } from "./mixins/printess/base_mixin";
import { CssMixin } from "./mixins/printess/css_mixin";
import { DuvelMoortgatBeerMixin } from "./mixins/printess/duvel_moortgat_beer_mixin";
import { FormFieldMixin } from "./mixins/printess/form_field_mixin";
import { ImagePlaceholderMixin } from "./mixins/printess/image_placeholder_mixin";
import { LayoutMixin } from "./mixins/printess/layout_mixin";
import { LogoMixin } from "./mixins/printess/logo_mixin";
import { MagicMenuAutomapMixin } from "./mixins/printess/magic_menu_automap_mixin";
import { MagicMenuPaletteMixin } from "./mixins/printess/magic_menu_palette_mixin";
import { PrintessCallbacksMixin } from "./mixins/printess/printess_callbacks_mixin";
import { ProductFormatMixin } from "./mixins/printess/product_format_mixin";
import { SwinkelsFamilyBreweryMixin } from "./mixins/printess/swinkels_family_brewery_mixin";

const ComposedController = composeMixins(
  Controller,
  BaseMixin,
  PrintessCallbacksMixin,
  ProductFormatMixin,
  CssMixin,
  DuvelMoortgatBeerMixin,
  FormFieldMixin,
  ImagePlaceholderMixin,
  LayoutMixin,
  LogoMixin,
  MagicMenuAutomapMixin,
  MagicMenuPaletteMixin,
  PrintessCallbacksMixin,
  SwinkelsFamilyBreweryMixin,
);

Stimulus.register(
  "printess",
  class extends ComposedController {
    static targets = [
      "container",
      "saveTokenInput",
      "formSubmitButton",
      "idmlSectionPrefixInput",
    ];

    static values = {
      afterSaveTargetSelector: String,
      basketId: String,
      customerLogoUploads: Object,
      editorUpdateEndpoint: String, // The endpoint on the menuez side which we use for lightweight fetch updates
      initialIdmlSectionPrefixFormField: String,
      selectIdmlSectionPrefixInPrintess: Boolean,
      shopToken: String,
      sourceMenuData: String,
      templateName: String,
    };

    static allowedPrintessBridgeMethods = [
      "editDuvelMoortgatBeer",
      "editSwinkelsFamilyBrewery",
      "selectImage",
      "selectProductFormat",
      "openPalettePanel",
    ];
  },
);
